import * as React from 'react';
import { toastr } from 'react-redux-toastr';
import * as ReactGA from 'react-ga';
import { IAgency, initialAgency } from '../../../../../share/types/agency';
import { AgenciesService } from '../../../../../share/services/agencies';
import * as _ from 'lodash';
import { Row, Col, Button } from 'reactstrap';
import { BeatLoader } from 'react-spinners';
import '../agencyView.css';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { connect } from 'react-redux';
import { IReduxState } from 'src/reduxTypes';
import { IAuthState } from 'src/modules/Auth/store/types';
import { getAgencyByRole } from 'src/share/utils/auth';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import { bindActionCreators } from 'redux';
import { loginActions } from 'src/modules/Auth/store/actions';
import { RoutesModules } from 'src/modules/Routing/types';

export interface IAgencyInfoState {
  agencyInfo: IAgency;
  loading: boolean,
  showDelete: boolean
  deleting: boolean
};

export interface IAgencyInfoProps {
  history: any;
  auth: IAuthState;
  match: any;
  getAgencies: () => Promise<any>
};

export class AgencyInfo extends React.Component<IAgencyInfoProps, IAgencyInfoState> {
  constructor(props: IAgencyInfoProps) {
    super(props);

    this.state = {
      agencyInfo: initialAgency,
      loading: true,
      showDelete: false,
      deleting: false
    }
  }

  public componentDidMount() {
    this.loadAgency();
  }

  public loadAgency = async () => {
    this.setState({ loading: true });
    const agencyCode = this.props.match.params.code;

    try {
      const res = await AgenciesService.getByID(agencyCode);
      if (!res) {
        throw { code: 1 }
      }
      this.setState({
        agencyInfo: _.cloneDeep(res),
        loading: false,
      });
    }
    catch (error) {
      toastr.error('Error', 'There was a problem loading the agency data');
      this.setState({ loading: false });
    }
  }

  public onEdit = () => {
    this.props.history.push(`/agencies/edit/${this.state.agencyInfo.code}`)
  }
  public onDelete = async () => {
    this.setState({ deleting: true })
    await AgenciesService.update(this.state.agencyInfo, { ...this.state.agencyInfo, disabled: true })
    await this.props.getAgencies()
    this.setState({ showDelete: false, deleting: false })
    ReactGA.event({
      category: 'Agency',
      action: 'Deleted agency',
      label: 'Agencies management'
    });
    this.props.history.replace(`/agencies`)

  }
  public modalToggle = () => {
    this.setState({ showDelete: !this.state.showDelete })
  }

  public render() {
    const { agencyInfo } = this.state;
    const admin = getAgencyByRole(this.props.auth) === 'ALL'
    return (
      <>
        {!this.state.loading && this.state.agencyInfo ?
          <div className="info-page">
            <div className="agency-info-container">
              <Row className="white-background ">
                <Col md="5" className="logo">
                  <img src={agencyInfo.logo ? agencyInfo.logo.url : ''} alt={agencyInfo.name} />
                </Col>
                <Col md="7">
                  <div className="agency-name">
                    <h1>{agencyInfo.name}</h1>
                    <p>{agencyInfo.code}</p>
                  </div>
                  <div className="agency-data">
                    <p><label>Country:</label><span className="subFont">{agencyInfo.country}</span></p>
                    <p><label>Contact name:</label><span className="subFont">{agencyInfo.contactperson}</span></p>
                    <p><label>Contact phone number:</label><span className="subFont">{agencyInfo.phone}</span></p>
                    <p><label>Email:</label><a href={`mailto:${agencyInfo.email}`}><span className="subFont">{agencyInfo.email}</span></a></p>
                  </div>
                  {
                    admin &&
                    <div className="controls">
                      <Button type="submit" id="submitBTN" className="btn btn-outline float-right btn-blue btnActions" onClick={this.onEdit}>
                        Edit
                    </Button>
                      <Button type="submit" id="submitBTN" className="btn btn-outline float-right btn-blue btnActions" onClick={this.modalToggle}>
                        Delete
                    </Button>
                    </div>
                  }
                </Col>
              </Row>
              <ConfirmationModal
                isOpen={this.state.showDelete}
                toggle={() => {
                  this.modalToggle();
                }}
                title={this.state.deleting ? `Deleting Agency ${agencyInfo.code}` : `Delete Agency ${agencyInfo.code}`}
                description={this.state.deleting ? `The agency is being deleted ` : `Are you sure you want to delete this agency`}
                onContinue={this.onDelete}
                loading={this.state.deleting}
                showButtons={!this.state.deleting}
              />
            </div>
          </div>
          : null
        }
        <div className="help-loader">
          <BeatLoader loading={this.state.loading} />
        </div>
      </>
    )
  }
}
const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});
const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({
    getAgencies: loginActions.getAgencies,
  }, dispatch);
}

export default SidebarContainer(RoutesModules.AGENCIES)(connect(mapStateToProps, mapDispatchToProps)(AgencyInfo));



// WEBPACK FOOTER //
// ./src/modules/Agencies/Agency/View/components/AgencyInfo.tsx